<template>
	<div>
		<lcsj-filter :show-search="false" more-text="更多筛选" @search="getListData()">
			<template #query>
				<el-button type="primary" size="small" icon="el-icon-search" @click="getListData">查询</el-button>
			</template>
			<template #actions></template>
			<el-form-item label="统计粒度：">
				<el-radio-group v-model="formInline.dateType" size="small" @input="changeDateType">
					<el-radio-button :label="1">按年</el-radio-button>
					<el-radio-button :label="2">按月</el-radio-button>
					<el-radio-button :label="3">按日</el-radio-button>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="日期：">
				<el-date-picker
					v-if="formInline.dateType === 1"
					v-model="inputDate"
					type="year"
					:clearable="false"
					value-format="yyyy"
					format="yyyy年"
					placeholder="选择年份"
					:editable="false"
					size="small"
					@change="changeDate"
				></el-date-picker>
				<el-date-picker
					v-else-if="formInline.dateType === 2"
					v-model="inputDate"
					type="month"
					:clearable="false"
					value-format="yyyy-MM"
					format="yyyy年MM月"
					placeholder="选择月份"
					:editable="false"
					size="small"
					@change="changeDate"
				></el-date-picker>
				<el-date-picker
					v-else
					v-model="inputDate"
					type="date"
					:clearable="false"
					value-format="yyyy-MM-dd"
					format="yyyy年MM月dd日"
					placeholder="选择日期"
					:editable="false"
					size="small"
					@change="changeDate"
				></el-date-picker>
			</el-form-item>
			<el-form-item label="所属门店：">
				<el-select filterable v-model="formInline.storeKeyId" placeholder="全部门店" clearable size="small" @change="getListData">
					<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			</lcsj-filter>
		<div class="statisticList">
			<div class="listTitle">{{ title }}</div>
			<el-table :cell-class-name="$moneyCellClass" v-loading="loading" :data="tableData" border stripe height="600" :row-class-name="tableRowClassName">
				<el-table-column prop="rowNumber" label="序号" align="center" width="70">
					<template #default="scope">
						{{ scope.row.isTotal ? "" : scope.row.rowNumber }}
					</template>
				</el-table-column>
				<el-table-column prop="storeName" label="所属门店" align="center" min-width="160" />
				<el-table-column v-for="(header, index) in payTypeHeaders" :key="index" :prop="'pay_' + header.payTypeId" :label="header.payTypeName" align="center" min-width="130">
					<template #default="scope">
						<span style="color: #07c160; font-weight: 600; white-space: nowrap">{{ formatMoney(scope.row["pay_" + header.payTypeId]) }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="total" label="合计" align="center" min-width="140">
					<template #default="scope">
						<span style="color: var(--app-danger-text); font-weight: bold; white-space: nowrap">{{ formatMoney(scope.row.total) }}</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import { GetPayAmountStatistic } from "@/api/payApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";

export default {
	data() {
		const now = new Date();
		return {
			loading: false,
			title: "各门店收款金额统计",
			inputDate: this.formatDefaultDate(now, 2),
			formInline: {
				dateType: 2,
				year: now.getFullYear(),
				month: now.getMonth() + 1,
				day: now.getDate(),
				storeKeyId: ""
			},
			storeList: [],
			payTypeHeaders: [],
			tableData: []
		};
	},

	created() {
		this.GetOrgInfoListByConfig();
		this.getListData();
	},

	methods: {
		// 生成不同粒度下的默认日期字符串
		formatDefaultDate(date, dateType) {
			const y = date.getFullYear();
			const m = String(date.getMonth() + 1).padStart(2, "0");
			const d = String(date.getDate()).padStart(2, "0");
			if (dateType === 1) return `${y}`;
			if (dateType === 3) return `${y}-${m}-${d}`;
			return `${y}-${m}`;
		},
		// 金额格式化
		formatMoney(val) {
			const num = parseFloat(val) || 0;
			return "￥" + num.toFixed(2) + " 元";
		},
		// 合计行高亮
		tableRowClassName({ row }) {
			return row.isTotal ? "total-row" : "";
		},
		// 切换统计粒度：重置日期为当前对应粒度默认值
		changeDateType() {
			this.inputDate = this.formatDefaultDate(new Date(), this.formInline.dateType);
			this.syncDateToForm();
			this.getListData();
		},
		// 选择日期
		changeDate() {
			this.syncDateToForm();
			this.getListData();
		},
		// 将 inputDate 解析到 formInline 的 year/month/day
		syncDateToForm() {
			if (!this.inputDate) return;
			const parts = this.inputDate.split("-");
			this.formInline.year = parseInt(parts[0]);
			if (parts.length >= 2) this.formInline.month = parseInt(parts[1]);
			if (parts.length >= 3) this.formInline.day = parseInt(parts[2]);
		},
		// 获取统计数据
		getListData() {
			this.loading = true;
			this.syncDateToForm();
			GetPayAmountStatistic(this.formInline)
				.then((res) => {
					if (res.code == 1 && res.data) {
						this.title = res.data.title;
						this.payTypeHeaders = res.data.payTypeHeaders || [];
						this.tableData = this.buildTableData(res.data.items || []);
					} else {
						this.payTypeHeaders = [];
						this.tableData = [];
						this.$message({ type: "info", message: res.msg });
					}
				})
				.catch(() => {
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 把后台 items 转成表格行（收款类型金额平铺到 pay_{payTypeId} 字段）
		buildTableData(items) {
			let seq = 0;
			return items.map((item) => {
				const row = {
					storeName: item.storeName,
					isTotal: item.isTotal,
					rowNumber: item.isTotal ? "" : ++seq,
					total: item.total
				};
				if (item.payList && Array.isArray(item.payList)) {
					item.payList.forEach((pay) => {
						row["pay_" + pay.payTypeId] = pay.payMoney;
					});
				}
				return row;
			});
		},
		// 获取门店列表
		GetOrgInfoListByConfig() {
			GetOrgInfoListByConfig({ key: 1 })
				.then((res) => {
					if (res.code == 1) {
						this.storeList = (res.data || []).map((item) => ({
							keyId: item.keyId,
							value: item.name + (item.remark2 ? "【" + item.remark2 + "】" : "")
						}));
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch(() => {
					this.$message.error("获取门店信息失败!");
				});
		}
	}
};
</script>

<style scoped lang="scss">
.statisticList {
	width: 100%;
	margin-top: 10px;
	padding: 20px;
	background-color: var(--app-surface);
	border-radius: 10px;
	box-sizing: border-box;
}

.listTitle {
	text-align: center;
	font-size: 18px;
	color: var(--app-text);
	font-weight: 700;
	margin-bottom: 16px;
}

.statisticList ::v-deep .total-row {
	background-color: var(--app-warning-soft);
	font-weight: bold;
}

.statisticList ::v-deep .total-row td {
	color: var(--app-warning);
}
</style>
